import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

dayjs.extend(duration);

export const TimeFormats = {
  base: 'DD/MM/YYYY',
  baseAndTime: 'DD/MM/YYYY HH:mm',
  print: 'YYYYMMDD-HHmmss',
} as const;

export const timeFormat = (minutes?: number) => {
  if (!minutes) {
    return '-';
  }
  const d = dayjs.duration(minutes, 'minutes');

  const days = d.days();
  const hours = d.hours();
  const mins = d.minutes();

  const parts: string[] = [];
  if (days) parts.push(`${days}d`);
  if (hours) parts.push(`${hours}h`);
  if (mins) parts.push(`${mins}m`);

  return parts.join(' ') || '0m';
};

export const minToHour = (minutes?: number) => {
  if (!minutes) {
    return '0h';
  }
  const d = dayjs.duration(minutes, 'minutes');
  return d.hours() + 'h';
};

export const formatDate = (
  date?: string,
  format = TimeFormats.base,
  defaultV = '-',
) => {
  if (!date) return defaultV;
  const d = dayjs(date);
  if (!d.isValid()) return defaultV;

  return d.format(format);
};
